import getDiaperBundleValue from './getDiaperBundleValue'
import pluralize from './pluralize'

export default function getDiaperDuration(amount: number, store: string) {
  const monthlyValue = getDiaperBundleValue(store)
  const numMonths = amount / monthlyValue
  if (numMonths > 0 && (Number.isInteger(numMonths) || numMonths >= 2)) {
    return { duration: Math.floor(numMonths), unit: pluralize(Math.ceil(numMonths), 'month') }
  }

  const numWeeks = Math.floor(amount / (monthlyValue / 4))
  if (numWeeks > 0 && (Number.isInteger(numWeeks) || numWeeks >= 2)) return { duration: numWeeks, unit: pluralize(numWeeks, 'week') }

  const numDays = Math.floor(amount / (monthlyValue / 30))
  return { duration: numDays, unit: pluralize(numDays, 'day') }
}
